{
  "deviceBasicInfoTab": {
    "required": "デバイス名を入力してください",
    "label2": "エリア",
    "label3": "デバイスID",
    "label4": "オプション機能",
    "label8": "デバイス名",
    "label9": "シリアル番号（任意）",
    "label10": "管理番号（任意）",
    "label11": "メモ（任意）"
  },
  "deviceEditDialog": {
    "enqueueSnackbar": "デバイス情報を更新しました",
    "enqueueSnackbar2": "映像設定を更新しました",
    "text2": "映像設定の更新に失敗しました",
    "enqueueSnackbar3": "IPカメラ設定を更新しました",
    "text3": "IPカメラ設定の更新に失敗しました",
    "label": "基本情報",
    "label2": "映像設定",
    "label3": "IPカメラ設定",
    "label4": "録画アップロード",
    "label5": "閲覧ユーザー",
    "text4": "更新中...",
    "title": "カメラ編集",
    "renderPlaceholder": "録画アップロード設定",
    "renderPlaceholder2": "録画アップロード設定は今後のアップデートで提供予定です。",
    "text5": "デバイス情報の更新に失敗しました"
  },
  "deviceFilterBar": {
    "placeholder": "デバイス名で検索"
  },
  "deviceIpCameraTab": {
    "label": "オン",
    "label2": "オフ",
    "text": "読み込み中...",
    "text2": "このデバイスにはIPカメラ設定がありません",
    "text3": "IPカメラ設定の取得に失敗しました",
    "label3": "セルフリターン",
    "text4": "オンにすると操作後、自動的にカメラの画角が初期位置に戻ります。",
    "text5": "設定を更新するとカメラが再起動します。"
  },
  "deviceMoveDialog": {
    "text": "既存のクリップ動画は「アーカイブ」へ自動で移動し、全体管理者のみ閲覧可能になります。",
    "text2": "クラウド録画（オプション）をご利用の場合、クラウド録画データは削除されます。",
    "text3": "名)",
    "text4": "閲覧ユーザー",
    "text5": "読み込み中...",
    "text6": "閲覧ユーザーの取得に失敗しました",
    "button": "再読み込み",
    "text7": "閲覧できるユーザーはいません",
    "text8": "移動先エリア",
    "text9": "ローカル録画データ",
    "text10": "閲覧権限",
    "text11": "エリアを選択してください",
    "enqueueSnackbar": "ユーザー情報が取得できません。",
    "text12": "選択したエリア",
    "enqueueSnackbar2": "{{deviceName}}を{{destinationName}}に移動します。",
    "text13": "{{deviceName}}のエリア移動に失敗しました。",
    "enqueueSnackbar3": "未選択の項目があります。すべて選択してください。",
    "text14": "{{deviceName}}のエリア移動",
    "text15": "エリア移動に失敗しました。",
    "text16": "より管理者にお問い合わせください。",
    "menuItem": "エリア情報の取得に失敗しました",
    "text17": "移動中...",
    "text18": "エリア移動する",
    "button2": "確認"
  },
  "deviceQualityTab": {
    "label": "なし",
    "label2": "有効",
    "label3": "無効",
    "text": "ローカル録画",
    "text2": "録画",
    "text3": "読み込み中...",
    "text4": "このデバイスには映像設定がありません",
    "text5": "映像設定の取得に失敗しました",
    "label4": "向きの回転",
    "label5": "配信-ビットレート",
    "label6": "{{recordingLabelPrefix}}-ビットレート",
    "label7": "{{recordingLabelPrefix}}-時刻表示",
    "text6": "圧縮転送量を増やすとネットワーク通信量が増加します。ご利用の環境に合わせて設定してください。",
    "text7": "設定を更新するとカメラが再起動します。"
  },
  "deviceTable": {
    "label": "デバイス名",
    "label2": "エリア",
    "label3": "カメラタイプ",
    "label4": "ユーザー数",
    "text": "エリア移動中",
    "text2": "エリア移動",
    "text3": "{{userCount}}名"
  },
  "deviceTableHeader": {
    "text": "件"
  },
  "deviceUserListPopover": {
    "unknownRoleLabel": "その他",
    "text2": "ユーザーがいません",
    "title": "{{deviceName}}のユーザー一覧"
  },
  "deviceUsersTab": {
    "text": "このデバイスを閲覧できるユーザーはいません",
    "text2": "ユーザー管理画面でユーザーにこのデバイスの閲覧権限を付与できます",
    "placeholder": "氏名・メールアドレス・権限で検索",
    "text3": "名前",
    "text4": "メールアドレス",
    "text5": "権限",
    "text6": "一致するユーザーがいません",
    "text7": "ユーザーの閲覧権限を変更する場合は、ユーザー管理画面で該当ユーザーを編集してください"
  },
  "device": {
    "title": "カメラ管理"
  },
  "buildChangeAreaConfirmModel": {
    "text": "不明",
    "label": "削除しない",
    "text2": "リセットする"
  },
  "deviceOptions": {
    "recordRetentionFallbackLabel": "30日",
    "text": "{{value}}ヶ月",
    "text2": "なし",
    "push": "PTZ操作",
    "push2": "通話",
    "push3": "定期録画",
    "push4": "クラウド録画（{{value}}）"
  },
  "moveDeviceOptions": {
    "label": "削除する",
    "description": "本体に保存されている録画データは削除すると元に戻せません",
    "label2": "削除しない",
    "description2": "本体の録画データはそのまま保持されます",
    "label3": "リセットする",
    "description3": "閲覧権限が初期化されます",
    "label4": "リセットしない",
    "description4": "現在閲覧中のユーザーの権限を保持します",
    "moveOptionPlaceholder": "選択してください"
  }
}
